import { useState } from 'react';

import { hasBookedHeidi2Demo, markHeidi2DemoBooked } from '../../data/heidi2DemoBooking';
import { Heidi2BookDemoModal } from './Heidi2BookDemoModal';
import { getHeidi2BookDemoCountryCode } from './heidi2BookDemo.countries';
import type { Heidi2BookDemoPort } from './heidi2Onboarding.types';

const US_BOOK_DEMO_URL =
  'https://meetings.hubspot.com/heidi-ii/contact-sales?uuid=3ab45adb-eae9-48ff-baae-802ef1e2c488&embed=true';
const AU_BOOK_DEMO_URL =
  'https://meetings.hubspot.com/heidi-ii/book-a-demo?uuid=4ebffbef-6214-42e4-a0a9-53e8297b4113&embed=true';

// When we need to support more countries, we only need to update this dictionary
const BOOK_DEMO_URL_BY_COUNTRY: Record<string, string | undefined> = {
  US: US_BOOK_DEMO_URL,
  AU: AU_BOOK_DEMO_URL,
};

export const useHeidi2BookDemo = (bookDemo: Heidi2BookDemoPort | undefined) => {
  const [isOpen, setIsOpen] = useState(false);
  // Seeded from storage so a booking taken in an earlier session still counts,
  // and held in state so the CTA re-renders the moment one is taken.
  const [hasBooked, setHasBooked] = useState(hasBookedHeidi2Demo);

  const userCountryCode = getHeidi2BookDemoCountryCode(bookDemo?.contact?.country);
  // On-prem ships no third-party embed, so those users get the in-product form
  // rather than an empty dialog.
  const meetingUrl =
    userCountryCode && !bookDemo?.isOnPrem
      ? BOOK_DEMO_URL_BY_COUNTRY[userCountryCode]
      : undefined;

  return {
    openBookDemo: () => setIsOpen(true),
    /** A demo is already booked, so the CTA has nothing left to offer. */
    hasBooked,
    modal: bookDemo ? (
      <Heidi2BookDemoModal
        open={isOpen}
        onOpenChange={setIsOpen}
        bookDemo={bookDemo}
        meetingUrl={meetingUrl}
        onBooked={() => {
          markHeidi2DemoBooked();
          setHasBooked(true);
        }}
      />
    ) : null,
  };
};
